import React, { Component } from 'react'
import {connect} from 'react-redux'
import {Button} from 'antd'
import Header from './common/header'
import Corousel from './common/corousel'

class StatusPage extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  componentWillMount() {
    localStorage.clear()
  }

  goToRegister = () => {
    const {history} = this.props
    history.push('/register')
  }

  render () {
    return (
      <div className='container'>
        <Header />
        <div className='content'>
          <Corousel />
          <div className='card'>
            <h1 style={{margin: '10px 0 20px 0'}}>Page Not Found</h1>
            <Button className='btnY' type='primary' size='large' onClick={this.goToRegister} style={{textAlign: 'center'}}>BACK TO REGISTER PAGE</Button>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
      registerStatus: state.Register
  }),
  { }
)(StatusPage);



// WEBPACK FOOTER //
// ./src/component/404.js